<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 4.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm.5 6a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm-.896 2.165a2.5 2.5 0 0 1 3.23 3.23l-3.23-3.23Zm-1.438 1.439a2.5 2.5 0 0 0 3.23 3.23l-3.23-3.23ZM9.498 9.5a12.95 12.95 0 0 0-7.583 2.438 1 1 0 0 0-.416.812v4.75a1 1 0 0 0 1 1H9.92a5.152 5.152 0 0 1 2.759-8.608 13.029 13.029 0 0 0-3.18-.392Z" />
    </svg>
</template>
